<template>
  <div class="pagina-certificado">

    <div id="seccionImprimir2" class="contenedor-cert">
      <img src="../../../assets/images/seminarios/diploma2.jpg" class="diploma-bg">

      <!-- Contenedor central de referencia -->
      <div class="contenido-central" :class="claseTamanoNombre">

        <!-- Nombre del participante -->
        <div class="nombre-participante" :class="claseTamanoNombre">
          <span class="a-prefijo">A:</span>
          {{ titlecase(usuario.nombres) }} {{ titlecase(usuario.apellidos) }}
        </div>

        <!-- Texto "Por su exitosa participación en:" -->
        <div class="texto-exitoso">
          Por su exitosa participación en:
        </div>

        <!-- Título de la capacitación -->
        <div class="titulo-capacitacion">
          {{ titlecase(nombreCapacitacion || encuesta.titulo) }}
        </div>

        <!-- Fecha en flujo, debajo del tema -->
        <div class="fecha-certificado">
          {{ fechaMostrar }}
        </div>

      </div>

      <!-- Firma del Capacitador -->
      <div v-if="firmaCapacitador" class="firma-container">
        <img
          ref="firmaImg"
          :src="$data_url + 'archivos/usuarios/firmas/' + firmaCapacitador"
          alt="Firma Capacitador"
          class="firma-img"
          @load="recortarFirmaBlanca"
        >
      </div>
    </div>

    <vs-popup title="Sigue estos pasos para descargar tu certificado" :active.sync="popupActivo">
      <div class="popup-descarga-cert">
        <img src="../../../assets/images/seminarios/tutorialDescarga.png" class="tutorial-descarga-img">
        <vs-button color="primary" class="btn-descargar-cert" type="gradient" @click="descargarCertificado()">Descargar</vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>
export default {
  data() {
    return {
      popupActivo: false,
      usuario: { nombres: '', apellidos: '' },
      encuesta: { titulo: '', codigo: '' },
      nombreCapacitacion: '',
      firmaCapacitador: null,
      fechaFin: ''
    }
  },
  computed: {
    fechaHoy() {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const dia = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${dia}`
    },
    fechaMostrar() {
      if (this.fechaFin) return String(this.fechaFin).split(/[ T]/)[0]
      return this.fechaHoy
    },
    claseTamanoNombre() {
      const nombre = `${this.usuario.nombres || ''} ${this.usuario.apellidos || ''}`.trim()
      const palabras = nombre ? nombre.split(/\s+/).length : 0
      if (nombre.length > 40 || palabras >= 5) return 'nombre-muy-largo'
      if (nombre.length > 22 || palabras >= 4) return 'nombre-largo'
      return ''
    }
  },
  mounted() {
    try {
      const u = localStorage.getItem('userEncuestaProlipa')
      const e = localStorage.getItem('dataEncuestaCertificado')
      const n = localStorage.getItem('nombreEntidadEncuesta')
      const f = localStorage.getItem('firmaCapacitadorEncuesta')
      const ff = localStorage.getItem('fechaFinEncuesta')
      if (u) this.usuario = JSON.parse(u)
      if (e) this.encuesta = JSON.parse(e)
      if (n) this.nombreCapacitacion = n
      if (f) this.firmaCapacitador = f
      if (ff) this.fechaFin = ff
    } catch (err) { }
    this.cargarDatosCertificado()
    this.valPopupDesc()
  },
  methods: {
    titlecase(value) {
      if (!value) return '';
      return value.toLowerCase().replace(/(?:^|\s)\S/g, function(char) {
        return char.toUpperCase();
      });
    },
    cargarDatosCertificado() {
      const asignacionId = localStorage.getItem('asignacionIdEncuesta')
      if (!asignacionId) return

      this.$http.get(this.$server_url + 'encuesta_prolipa/asignaciones/' + asignacionId + '/datos-certificado')
        .then(res => {
          const data = res.data
          if (data.fecha_fin) {
            this.fechaFin = String(data.fecha_fin).split(/[ T]/)[0]
            localStorage.setItem('fechaFinEncuesta', this.fechaFin)
          }
          if (!this.nombreCapacitacion && data.nombre_entidad) {
            this.nombreCapacitacion = data.nombre_entidad
            localStorage.setItem('nombreEntidadEncuesta', data.nombre_entidad)
          }
          if (!this.firmaCapacitador && data.firma_capacitador) {
            this.firmaCapacitador = data.firma_capacitador
            localStorage.setItem('firmaCapacitadorEncuesta', data.firma_capacitador)
          }
        })
        .catch(() => { })
    },
    valPopupDesc() {
      setTimeout(() => {
        if (!this.popupActivo) {
          this.popupActivo = true
        }
      }, 3000)
    },
    descargarCertificado() {
      this.popupActivo = false
      const nombreArchivo = 'certificado_' + (this.encuesta.codigo || 'encuesta').replace('ENC_', 'CAP_')
      document.title = nombreArchivo

      try {
        const payload = {
          encuesta_id: this.encuesta.id,
          usuario_id: this.usuario.idusuario,
        }
        const asignacionId = localStorage.getItem('asignacionIdEncuesta')
        if (asignacionId) payload.asignacion_id = asignacionId

        this.$http.post(this.$server_url + 'encuesta_prolipa/registrar-descarga', payload)
          .catch(() => { })
      } catch (e) { }

      setTimeout(() => {
        window.print()
      }, 1000)
    },
    recortarFirmaBlanca(event) {
      const img = event.target
      if (!img || !img.naturalWidth) return

      try {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = img.naturalWidth
        canvas.height = img.naturalHeight
        ctx.drawImage(img, 0, 0)

        const { data, width, height } = ctx.getImageData(0, 0, canvas.width, canvas.height)
        const umbral = 245
        let top = height
        let left = width
        let right = 0
        let bottom = 0

        for (let y = 0; y < height; y++) {
          for (let x = 0; x < width; x++) {
            const i = (y * width + x) * 4
            const r = data[i]
            const g = data[i + 1]
            const b = data[i + 2]
            const a = data[i + 3]
            const esBlanco = a < 12 || (r >= umbral && g >= umbral && b >= umbral)
            if (!esBlanco) {
              if (x < left) left = x
              if (x > right) right = x
              if (y < top) top = y
              if (y > bottom) bottom = y
            }
          }
        }

        if (right <= left || bottom <= top) return

        const cropW = right - left + 1
        const cropH = bottom - top + 1
        const recortado = document.createElement('canvas')
        recortado.width = cropW
        recortado.height = cropH
        recortado.getContext('2d').drawImage(canvas, left, top, cropW, cropH, 0, 0, cropW, cropH)
        img.src = recortado.toDataURL('image/png')
      } catch (err) {
        // Si CORS bloquea el canvas, mix-blend-mode en CSS hace el efecto visual
      }
    }
  }
}
</script>

<style>
@font-face {
  font-family: "font_diploma";
  src: url("../../../assets/images/seminarios/SavoyePlain.otf");
}

/* Estilos base */
.pagina-certificado {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
}

.popup-descarga-cert {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tutorial-descarga-img {
  width: 100%;
  display: block;
}

.btn-descargar-cert {
  width: 100%;
}

.contenedor-cert {
  position: relative;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
}

.diploma-bg {
  width: 100%;
  height: auto;
  max-width: 1280px;
  display: block;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* Contenedor central de referencia */
.contenido-central {
  position: absolute;
  top: 57%;
  left: 48%;
  transform: translate(-50%, -50%);
  width: 72%;
  max-width: 900px;
  text-align: center;
  padding: 0 10% 0 6%;
  box-sizing: border-box;
}

/* Nombre del participante */
.nombre-participante {
  font-weight: bold;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: clamp(18px, 4vw, 48px);
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
  margin-top: -1cm;
  margin-bottom: 20px;
  color: #2c3e50;
  line-height: 1.3;
}

.contenido-central.nombre-largo {
  top: 58.5%;
  transform: translate(-50%, -47%);
  padding: 0 16% 0 6%;
}

.nombre-participante.nombre-largo {
  margin-top: 0.35cm;
  margin-bottom: 14px;
  line-height: 1.1;
  font-size: clamp(17px, 3.6vw, 42px);
}

.nombre-participante.nombre-muy-largo {
  font-size: clamp(15px, 3.2vw, 36px);
  margin-top: 0.5cm;
  line-height: 1.1;
}

.a-prefijo {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
}

/* Texto "Por su exitosa participación en:" */
.texto-exitoso {
  font-family: 'font_diploma', cursive;
  font-weight: 700;
  line-height: 1.2;
  font-size: clamp(16px, 3vw, 38px);
  text-align: center;
  margin-bottom: 15px;
  color: #1a1a1a;
  word-wrap: break-word;
}

/* Título de la capacitación */
.titulo-capacitacion {
  font-family: 'font_diploma', cursive;
  line-height: 1.3;
  font-size: clamp(14px, 2.8vw, 48px);
  text-align: center;
  word-wrap: break-word;
  color: #1a1a1a;
  padding: 0 10px;
  margin-bottom: 10px;
}

/* Fecha del certificado - debajo del tema, en flujo normal */
.fecha-certificado {
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
  color: #333;
  margin-top: 8px;
  font-size: clamp(10px, 1.6vw, 18px);
  white-space: nowrap;
}

/* Contenedor de la firma - anclado justo sobre la línea "Capacitador" */
.firma-container {
  position: absolute;
  top: 87%;
  left: 63%;
  transform: translate(-50%, -100%);
  width: 14%;
  min-width: 60px;
  max-width: 180px;
  height: auto;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.firma-img {
  max-width: 100%;
  max-height: 80px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  mix-blend-mode: multiply;
}

/* Configuración de impresión - horizontal, anclada a la imagen del diploma */
@page {
  size: letter landscape;
  margin: 0;
}

@media print {
  @page {
    size: letter landscape;
    margin: 0;
  }

  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  body, html {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background: white !important;
    overflow: hidden !important;
  }

  /* Solo imprimir el certificado (evita cortes en Chrome Android) */
  body * {
    visibility: hidden;
  }

  .pagina-certificado,
  .pagina-certificado * {
    visibility: visible;
  }

  .pagina-certificado {
    position: fixed;
    left: 0;
    top: 0;
    width: 100% !important;
    height: 100% !important;
    min-height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
    background: white !important;
    overflow: hidden !important;
  }

  .contenedor-cert {
    position: relative !important;
    width: 100% !important;
    max-width: none !important;
    height: 100% !important;
    min-height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    page-break-after: avoid !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    background: white !important;
    display: block !important;
    overflow: hidden !important;
  }

  .diploma-bg {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    display: block !important;
    margin: 0 !important;
    box-shadow: none !important;
    object-fit: fill !important;
    page-break-inside: avoid !important;
  }

  .contenido-central {
    top: 57%;
    left: 48%;
    width: 72%;
    padding: 0 10% 0 6%;
  }

  .nombre-participante {
    font-size: 28px;
    margin-top: -1cm;
    margin-bottom: 15px;
  }

  .contenido-central.nombre-largo {
    top: 58.5%;
    padding: 0 16% 0 6%;
  }

  .nombre-participante.nombre-largo {
    margin-top: 0.35cm;
    margin-bottom: 12px;
  }

  .nombre-participante.nombre-muy-largo {
    font-size: 24px;
    margin-top: 0.45cm;
  }

  .texto-exitoso {
    font-size: 24px;
    margin-bottom: 10px;
  }

  .titulo-capacitacion {
    font-size: 34px;
    margin-bottom: 12px;
  }

  .fecha-certificado {
    font-size: 14px;
    margin-top: 6px;
  }

  .firma-container {
    top: 87%;
    left: 63%;
    transform: translate(-50%, -100%);
    width: 14%;
    max-width: 180px;
  }

  .firma-img {
    max-height: 80px;
  }

  .vs-popup--background,
  .vs-popup--content {
    display: none !important;
  }
}

/* Responsive para tablets */
@media screen and (max-width: 1024px) and (min-width: 768px) {
  .contenido-central {
    top: 58%;
    width: 74%;
    padding: 0 10% 0 6%;
  }

  .nombre-participante {
    margin-bottom: 12px;
  }

  .texto-exitoso {
    margin-bottom: 8px;
  }

  .titulo-capacitacion {
    margin-bottom: 10px;
  }

  .fecha-certificado {
    margin-top: 6px;
  }

  .firma-container {
    top: 87%;
    left: 62.5%;
    width: 15%;
    max-width: 150px;
  }
}

/* Responsive para móviles */
@media screen and (max-width: 767px) {
  .pagina-certificado {
    min-height: auto;
    align-items: flex-start;
    padding: 8px 0 16px;
  }

  .contenido-central {
    top: 57%;
    left: 48%;
    transform: translate(-50%, -50%);
    width: 76%;
    padding: 0 10% 0 6%;
  }

  .nombre-participante {
    font-size: clamp(14px, 4.2vw, 22px);
    margin-top: -0.7cm;
    margin-bottom: 6px;
    line-height: 1.2;
  }

  .contenido-central.nombre-largo {
    top: 59%;
    transform: translate(-50%, -46%);
    padding: 0 14% 0 6%;
  }

  .nombre-participante.nombre-largo {
    margin-top: 0.3cm;
    margin-bottom: 5px;
    line-height: 1.1;
  }

  .nombre-participante.nombre-muy-largo {
    font-size: clamp(12px, 3.5vw, 18px);
    margin-top: 0.4cm;
    line-height: 1.1;
  }

  .texto-exitoso {
    font-size: clamp(12px, 3.2vw, 18px);
    margin-bottom: 5px;
  }

  .titulo-capacitacion {
    font-size: clamp(11px, 2.8vw, 16px);
    margin-bottom: 6px;
    line-height: 1.25;
  }

  .fecha-certificado {
    font-size: clamp(9px, 1.8vw, 12px);
    margin-top: 4px;
  }

  .firma-container {
    top: 86.5%;
    left: 62%;
    width: 18%;
    max-width: 90px;
  }

  .firma-img {
    max-height: 32px;
  }
}

/* Responsive para móviles pequeños */
@media screen and (max-width: 480px) {
  .contenido-central {
    top: 57%;
    transform: translate(-50%, -50%);
    width: 80%;
    padding: 0 10% 0 6%;
  }

  .nombre-participante {
    margin-top: -0.6cm;
    margin-bottom: 4px;
  }

  .contenido-central.nombre-largo {
    top: 59%;
    transform: translate(-50%, -45%);
    padding: 0 14% 0 6%;
  }

  .nombre-participante.nombre-largo {
    margin-top: 0.28cm;
    margin-bottom: 4px;
    line-height: 1.1;
  }

  .nombre-participante.nombre-muy-largo {
    margin-top: 0.38cm;
    font-size: clamp(11px, 3.2vw, 16px);
    line-height: 1.1;
  }

  .texto-exitoso {
    margin-bottom: 4px;
  }

  .titulo-capacitacion {
    margin-bottom: 5px;
  }

  .fecha-certificado {
    margin-top: 3px;
  }

  .firma-container {
    top: 86%;
    left: 61.5%;
    width: 20%;
    max-width: 70px;
  }

  .firma-img {
    max-height: 26px;
  }
}

/* Pantallas grandes */
@media screen and (min-width: 1920px) {
  .contenido-central {
    max-width: 1200px;
    padding: 0 10% 0 6%;
  }

  .nombre-participante {
    font-size: 52px;
  }

  .texto-exitoso {
    font-size: 42px;
  }

  .titulo-capacitacion {
    font-size: 42px;
    margin-bottom: 20px;
  }

  .fecha-certificado {
    font-size: 22px;
    margin-top: 10px;
  }

  .firma-container {
    width: 16%;
    max-width: 220px;
  }

  .firma-img {
    max-height: 100px;
  }
}
</style>
